import type { TeaseWallConfig } from './tease-wall.config';

export class TeaseWallContext<TData> {

	constructor (
		public $implicit: TData,
		public config: TeaseWallConfig
	) {}
}
